import { Injectable } from '@angular/core';
import { createEffect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { of } from 'rxjs';
import * as fromMaintenanceschedule from './maintenance-schedule.actions';
import { MaintenanceScheduleState } from './maintenance-schedule.interfaces';
import { ApiService } from '@quorum/api';
// eslint-disable-next-line max-len
import { VehicleMaintenanceSchedule } from '@quorum/models/xs-resource';
import { map } from 'rxjs/operators';
@Injectable()
export class MaintenanceScheduleEffects {
  
  getMaintenanceScheduleFromServer = createEffect(() => this.dataPersistence.fetch(
    fromMaintenanceschedule.GET_MAINTENANCE_SCHEDULES_FROM_SERVER,
    {
      run: (action: fromMaintenanceschedule.GetMaintenanceSchedulesFromServer, state: MaintenanceScheduleState) => {
        return this.apiService
          .get<VehicleMaintenanceSchedule[]>(`v/1/vehicles/vehicle-maintenance-schedules`, {
            params: action.payload
          })
          .pipe(
            map(
              maintenanceSchedules =>
                new fromMaintenanceschedule.GetMaintenanceSchedulesFromServerSuccess({
                  maintenanceSchedules: maintenanceSchedules
                })
            )
          );
      },
      onError: (action: fromMaintenanceschedule.GetMaintenanceSchedulesFromServer, error) => {
        console.error('Error', error);
      }
    }
  ));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<MaintenanceScheduleState>,
    private apiService: ApiService
  ) {}
}
